import Portal from '../Portal';
import Dialog from './Dialog.vue';

export default {
  name: 'Dialog',
  props: Dialog.props,
  functional: true,
  render(h, context) {
    const slots = context.slots();
    const children = Object.keys(slots).reduce((arr, key) => arr.concat(slots[key]), []);

    let dialogNode = h(
      Dialog,
      {
        // 透传 event 和 props
        on: context.listeners,
        props: {
          ...context.props,
        },
        // 透传 scopedSlots
        scopedSlots: context.scopedSlots,
        attrs: context.attrs,

        class: context.data.class,
        staticClass: context.data.staticClass,
      },
      children
    );
    if (context.props.animation) {
      dialogNode = h(
        'transition',
        {
          attrs: {
            name: 'fade',
            // appear: true,
          },
        },
        [dialogNode]
      );
    }

    return h(Portal, [dialogNode]);
  },
};
